import React, { useState, useRef, useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import '../../styles/components/destination_page/Tabs.css';

const Tabs = ({ tabs, children }) => {
  const [activeTab, setActiveTab] = useState(tabs[0].label);
  const [userInteracted, setUserInteracted] = useState(false);
  const tabsRef = useRef([]);
  const headerRef = useRef(null);
  const validChildren = React.Children.toArray(children).filter(child => React.isValidElement(child));

  useLayoutEffect(() => {
    const activeIndex = tabs.findIndex(tab => tab.label === activeTab);
    if (tabsRef.current[activeIndex]) {
      if (!userInteracted) {
        //tabsRef.current[activeIndex].focus({ preventScroll: true });
      } else {
        const navbarHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--navbar-height'), 10) || 0;
        const headerTop = headerRef.current.getBoundingClientRect().top + window.pageYOffset;
        window.scrollTo({ top: headerTop - navbarHeight, behavior: 'smooth' });
      }
    }
  }, [activeTab, tabs, userInteracted]);

  const handleClick = (label) => {
    setUserInteracted(true);
    setActiveTab(label);
  };

  const handleKeyDown = (e, index) => {
    const { key } = e;
    let newIndex = index;
    if (key === 'ArrowRight') {
      newIndex = (index + 1) % tabs.length;
      setUserInteracted(true);
      setActiveTab(tabs[newIndex].label);
    } else if (key === 'ArrowLeft') {
      newIndex = (index - 1 + tabs.length) % tabs.length;
      setUserInteracted(true);
      setActiveTab(tabs[newIndex].label);
    }
  };

  return (
    <div className="tabs-container">
      <div className="tabs-header" role="tablist" ref={headerRef}>
        {tabs.map((tab, index) => (
          <button
            key={tab.label}
            role="tab"
            aria-selected={activeTab === tab.label}
            aria-controls={`panel-${tab.label}`}
            id={`tab-${tab.label}`}
            className={`tab-button ${activeTab === tab.label ? 'active' : ''}`}
            onClick={() => handleClick(tab.label)}
            onKeyDown={(e) => handleKeyDown(e, index)}
            ref={el => tabsRef.current[index] = el}
            tabIndex={activeTab === tab.label ? 0 : -1}
          >
            {tab.icon && <span className="tab-icon">{tab.icon}</span>}
            {tab.label}
          </button>
        ))}
      </div>
      <div className="tabs-content" role="region" aria-live="polite">
        {validChildren.map(child =>
          child.props.label === activeTab ? (
            <div
              key={child.props.label}
              role="tabpanel"
              id={`panel-${child.props.label}`}
              aria-labelledby={`tab-${child.props.label}`}
              className="tab-panel"
            >
              {child.props.children}
            </div>
          ) : null
        )}
      </div>
    </div>
  );
};

Tabs.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      icon: PropTypes.element,
    })
  ).isRequired,
  children: PropTypes.node,
};

export default Tabs;
